import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getPaymentTypes = createAsyncThunk(
  'deliveryCouriersPayments/getPaymentTypes',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/getPaymentTypes?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getCouriersTransactions = createAsyncThunk(
  'deliveryCouriersPayments/getDetailsDeliveryServiceCourier',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/getDetailsDeliveryServiceCourier?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          couriersTransactions: response.data.data.data || [],
          periods: response.data.data.period || [],
          filters: data,
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createCourierTransaction = createAsyncThunk(
  'deliveryCouriersPayments/createCourierTransaction',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/createCourierPayment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createCouriersPayment = createAsyncThunk(
  'deliveryCouriersPayments/createCouriersPayment',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/createCourierPay?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getCouriersPayments = createAsyncThunk(
  'deliveryCouriersPayments/getCouriersPayments',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/getCourierPayList?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          data: response.data.data,
          filters: {...data.filters, deliveryServiceId: data.deliveryServiceId},
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateCourierPayment = createAsyncThunk(
  'deliveryCouriersPayments/updateCourierPayment',
  async (data, { rejectWithValue }) => {
    const api = '/courierPayments/updateCourierPayStatus?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const initialState = {
  getPaymentTypesStatus: null,
  getCouriersTransactionsStatus: null,
  createCourierTransactionStatus: null,
  createCouriersPaymentStatus: null,
  getCouriersPaymentsStatus: null,
  updateCourierPaymentStatus: null,

  paymentTypes: null,
  filters: {
    deliveryServiceId: null,
    dateFrom: null,
    dateTo: null,
  },
  selectedRaces: [],

  couriersTransactions: [],
  periods: [],
  selectedCells: [],
  modalCellData: null,

  couriersPayments: [],
  currentPage: 1,
  totalPages: 1,
  total: 0,
};

const deliveryCouriersPaymentsSlice = createSlice({
  name: 'deliveryCouriersPayments',
  initialState,
  extraReducers: (builder) => {
    builder
      //getPaymentTypes
      .addCase(getPaymentTypes.pending, (state) => { state.getPaymentTypesStatus = 'pending'; })
      .addCase(getPaymentTypes.fulfilled, (state, action) => { state.getPaymentTypesStatus = 'fulfilled'; state.paymentTypes = action.payload; })
      .addCase(getPaymentTypes.rejected, (state) => { state.getPaymentTypesStatus = 'rejected'; })

      //getCouriersTransactions
      .addCase(getCouriersTransactions.pending, (state) => { state.getCouriersTransactionsStatus = 'pending'; })
      .addCase(getCouriersTransactions.fulfilled, (state, action) => {
        state.getCouriersTransactionsStatus = 'fulfilled';
        state.couriersTransactions = action.payload.couriersTransactions;
        state.periods = action.payload.periods;
        state.filters = action.payload.filters;
      })
      .addCase(getCouriersTransactions.rejected, (state) => { state.getCouriersTransactionsStatus = 'rejected'; })

      //createCourierTransaction
      .addCase(createCourierTransaction.pending, (state) => { state.createCourierTransactionStatus = 'pending'; })
      .addCase(createCourierTransaction.fulfilled, (state) => { state.createCourierTransactionStatus = 'fulfilled'; })
      .addCase(createCourierTransaction.rejected, (state) => { state.createCourierTransactionStatus = 'rejected'; })

      //createCouriersPayment
      .addCase(createCouriersPayment.pending, (state) => { state.createCouriersPaymentStatus = 'pending'; })
      .addCase(createCouriersPayment.fulfilled, (state) => { state.createCouriersPaymentStatus = 'fulfilled'; state.selectedCells = []; })
      .addCase(createCouriersPayment.rejected, (state) => { state.createCouriersPaymentStatus = 'rejected'; })

      //getCouriersPayments
      .addCase(getCouriersPayments.pending, (state) => { state.getCouriersPaymentsStatus = 'pending'; })
      .addCase(getCouriersPayments.fulfilled, (state, action) => {
        state.getCouriersPaymentsStatus = 'fulfilled';
        state.couriersPayments = action.payload.data.items;
        state.currentPage = action.payload.data.pagination.currentPage;
        state.totalPages = action.payload.data.pagination.totalPages;
        state.total = action.payload.data.pagination.total;
        state.filters = action.payload.filters;
      })
      .addCase(getCouriersPayments.rejected, (state) => { state.getCouriersPaymentsStatus = 'rejected'; })

      //updateCourierPayment
      .addCase(updateCourierPayment.pending, (state) => { state.updateCourierPaymentStatus = 'pending'; })
      .addCase(updateCourierPayment.fulfilled, (state) => { state.updateCourierPaymentStatus = 'fulfilled'; })
      .addCase(updateCourierPayment.rejected, (state) => { state.updateCourierPaymentStatus = 'rejected'; })

      // PURGE
      .addCase(PURGE, () => initialState);
  },
  reducers: {
    clearState: (state) => {
      state.filters = {
        deliveryServiceId: null,
        dateFrom: null,
        dateTo: null,
      };
      state.selectedRaces = [];
      state.couriersTransactions = [];
      state.periods = [];
      state.getCouriersTransactionsStatus = null;
      state.selectedCells = [];
      state.couriersPayments = [];
      state.currentPage = 1;
      state.totalPages = 1;
      state.getCouriersPaymentsStatus = null;
    },
    setSelectedRaces: (state, action) => {
      state.selectedRaces = action.payload;
    },
    setSelectedCells: (state, action) => {
      state.selectedCells = action.payload;
    },
    setModalCellData: (state, action) => {
      state.modalCellData = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

export const {
  clearState,
  setSelectedRaces,
  setSelectedCells,
  setModalCellData,
  setCurrentPage,
} = deliveryCouriersPaymentsSlice.actions;

export default deliveryCouriersPaymentsSlice.reducer;
